module.exports = __webpack_public_path__ + "img/activity_ico2.57bd2947.png";